import React from "react";
import styled from "styled-components";
import { IonIcon } from "@ionic/react";
import { checkmarkCircle, ellipse } from "ionicons/icons";

const Row = styled.div`
  display: flex;
  margin: 4px;
  padding: 0px 8px 0px 8px;
  border: 1px solid grey;
  background: #3880ff;
  color: white;
`;
const Checkbox = styled.div`
  margin-left: 16px;
  align-self: center;
`;
const CheckboxIcon = styled(IonIcon)`
  font-size: 2em;
`;

const Label = styled.div`
  padding-left: 16px;
  align-self: center;
`;

const FormCheckboxRow = (props) => {
  const { value, onChange } = props.input;

  return (
    <Row
      onClick={() => {
        onChange(!value);
      }}
    >
      <Checkbox>
        {value ? (
          <CheckboxIcon color="success" icon={checkmarkCircle} />
        ) : (
          <CheckboxIcon icon={ellipse} />
        )}
      </Checkbox>
      <Label>{props.label}</Label>
    </Row>
  );
};

export default FormCheckboxRow;
